import React, { useState, useEffect } from 'react';
import Time from '../Components/Time';
import ShowDate from '../Components/ShowDate';
import '../App.css';
import StationName from '../Components/StationName';
import LegList from '../Components/LegList';
import { Popup } from '../Components/Popup/Popup';
import Route from '../Definitions/Route';
import EditTrip from './EditTrip';
import SettingsIcon from '@mui/icons-material/Settings';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * Show one trip in a tr-row
 * @param props 
 * @returns JSX.Element
 */
const ShowTrip = (props:
	{
		routes: Route[],
		coords: any,
		reverse: boolean,
		hidden: boolean,
		id: number,
		cbToggleVisible: (nr: number) => void,
		cbSaveRoute: (nr: number, route: Route) => void,
		cbDeleteRoute: (nr: number) => void,
	}): JSX.Element => {
	let { routes, cbSaveRoute, cbDeleteRoute, cbToggleVisible, hidden, reverse, coords, id } = props;
	const [editRoute, setEditRoute] = useState(false);
	const toggleEditRoute = () => setEditRoute(!editRoute);

	const saveRoute = (nr: number, route: Route) => {
		toggleEditRoute();
		cbSaveRoute(nr, route);
	}

	const toggleVisible = () => {
		cbToggleVisible(id);
	}

	let route = routes[id];
	let start = route.start;
	let end = route.end;
	if (reverse) {
		start = route.end;
		end = route.start;
	}
	const [result, setResult] = useState({} as any)
	const [loading, setLoading] = useState(false);
	const ShowTimeRow = (props: {
		item: any;
		idx: number;
		last: boolean;
	}) => {
		const { item, idx, last } = props;
		const [showLegList, setShowLegList] = useState(false);
		const setLeg = (mode: boolean) => {
			setShowLegList(mode);
		}
		return (
			<>
				<tr
					onClick={() => { setLeg(!showLegList) }}
					className={loading ? "blur" : (showLegList ? "leglistshown" : "")}
				>
					<td colSpan={2}>
						<ShowDate date={item.Origin?.date} />
					</td>
					<td>
						<Time time={item.Origin?.time} />
						&nbsp;=&gt;&nbsp;
						<Time time={item.Destination?.time} />
					</td>
					<td>
						{idx === 0 && !loading && startTime.date !== "" ?
							<button
								onClick={() => updateStartTime("", "")}
							>
								🕑 Nu
							</button>
							: <></>
						}
						{last && !loading ?
							<button
								onClick={() => updateStartTime(item.Origin.date, item.Origin.time, route.numResult === "1")}
							>
								🕑 Senare
							</button>
							: <></>
						}
					</td>
					<td></td>
				</tr >
				{
					showLegList ?
						<tr
							onClick={() => { setLeg(!showLegList) }}
						>
							< td colSpan={5} className='leglist' >
								<LegList leglist={item.LegList.Leg} />
							</td >
						</tr >
						: <></>
				}
			</>
		);
	}

	let [startTime, setStartTime] = useState({ date: "", time: "" })
	const api_key = "5cf3315d-fcd1-476e-ada7-65448cf49d48";

	const fetchData = () => {
		setLoading(true);
		let url = "https://api.resrobot.se/v2.1/trip?" +
			"format=json" +
			"&date=" + startTime.date +
			"&time=" + startTime.time +
			"&passlist=false" +
			"&showPassingPoints=true" +
			"&accessId=" + api_key;
		if (start.id === "here") {
			if (!coords?.latitude)
				return;
			url += "&originWalk=1";
			url += "&originCoordLat=" + coords?.latitude;
			url += "&originCoordLong=" + coords?.longitude;
		} else {
			url += "&originWalk=0";
			url += "&originId=" + start.id;
		}
		if (end.id === "here") {
			if (!coords?.latitude)
				return;
			url += "&destWalk=1";
			url += "&destCoordLat" + coords?.latitude;
			url += "&destCoordLong=" + coords?.longitude;
		} else {
			url += "&destWalk=0";
			url += "&destId=" + end.id;
		}

		return fetch(url)
			.then((response) => response.json())
			.then((data) => {
				setResult(data);
				setLoading(false);
			});
	}

	useEffect(() => {
		fetchData();
	}, []);

	/**
	 * Load data for selected time.
	 * @param date 
	 * @param time 
	 * @param plusone 
	 */
	const updateStartTime = (date: string, time: string, plusone = false) => {
		if (plusone) {
			let tmp = new Date(date + " " + time)
			tmp.setMinutes(tmp.getMinutes() + 1);
			date = tmp.toISOString().substring(0, 10);
			time = tmp.toLocaleTimeString('sv-SE');
		}
		startTime = { date: date, time: time };
		setStartTime({ ...startTime });
		fetchData();
	}
	if (editRoute) {
		return <EditTrip
			cbSave={saveRoute}
			routes={routes}
			route={route}
			reverse={reverse}
			id={id}
			cbCancel={toggleEditRoute}
			cbDelete={cbDeleteRoute} />
	}

	if (hidden) {
		return (
			<table>
				<tbody>
					<tr onClick={toggleVisible}>
						<td>
							<ExpandMoreIcon fontSize='inherit' />
						</td>
						<td>
							<StationName name={result?.Trip ? result?.Trip[0]?.Origin?.name : start.name} />
							{result?.Trip?.length > 0 ?
								<>
									&nbsp;
									<Time time={result.Trip[0].Origin?.time} />
								</>
								: <></>
							}
						</td>
						<td>=&gt;</td>
						<td>
							<StationName name={result?.Trip ? result?.Trip[0]?.Destination?.name : end.name} />
							{result?.Trip?.length > 0 ?
								<>
									&nbsp;
									<Time time={result.Trip[0].Destination?.time} />
								</>
								: <></>
							}
						</td>
					</tr>
				</tbody>
			</table >
		);
	}

	if (!result?.Trip) {
		// Blurred view
		return (
			<table>
				<tbody>
					<tr onClick={toggleVisible}>
						<td>
							<ExpandLessIcon fontSize='inherit' />
						</td>
						<td>Från:</td><td><StationName name={start.name} /></td>
					</tr>
					{result?.errorText !== undefined ?
						<tr><td colSpan={4}>{result?.errorText}</td></tr>
						:
						[...Array(route.numResult)].map((e, i) =>
							<tr key={i}><td></td><td></td><td className="blur">NA:NA =&gt; NA:NA</td></tr>
						)
					}
					<tr>
						<td>
							<SettingsIcon onClick={toggleEditRoute} />
						</td>
						<td>Till:</td><td><StationName name={end.name} /></td></tr>
				</tbody>
			</table >
		);
	}

	return (
		<table>
			<tbody>
				<tr onClick={toggleVisible}>
					<td>
						<ExpandLessIcon fontSize='inherit' />
					</td>
					<td>Från:</td><td colSpan={2}>
						<StationName name={result?.Trip[0]?.Origin?.name} />
					</td>
				</tr>
				{result?.Trip?.map((item: any, idx: number) => {
					if (idx >= parseInt(route.numResult))
						return <React.Fragment key={idx}></React.Fragment>
					return (
						<ShowTimeRow
							key={idx}
							item={item}
							idx={idx}
							last={idx === parseInt(route.numResult) - 1 || idx === result.length - 1}
						/>
					)
				}
				)}
				<tr>
					<td>
						<SettingsIcon fontSize='inherit' onClick={toggleEditRoute} />
					</td>
					<td>Till:</td><td colSpan={2}>
						<StationName name={result?.Trip[0]?.Destination?.name} />
					</td></tr>
			</tbody>
		</table >
	);
};

export default ShowTrip;